import { Pipe, PipeTransform } from '@angular/core';
import { Countries } from 'core/geography';
import { isNilOrEmpty } from 'helpers';
/*
 * Converts 2 digit country code into long form
 *
 * Example:
 *   {{ 'CA' | countryLong }}
 *   formats to: 'Canada'
*/
@Pipe({name: 'countryLong'})
export class CountryLongPipe implements PipeTransform {
  transform(value: any) {
    const country = Countries.find(c => c.abbreviation.toUpperCase() === (value || '').toUpperCase());
    if (isNilOrEmpty(country)) {
      console.warn(`Invalid country ${value}`);
      return value;
    }

    return country.name;
  }
}
